import { getDownloadURL, ref, type FirebaseStorage } from "firebase/storage";

/**
 * Returns audio duration in seconds (`HTMLAudioElement.duration`).
 */
export async function getAudioDuration(filePath: string, storage: FirebaseStorage): Promise<number> {
  const fileRef = ref(storage, filePath);
  const url = await getDownloadURL(fileRef);

  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.addEventListener("loadedmetadata", () => {
      resolve(audio.duration);
    });
    audio.addEventListener("error", reject);
    audio.src = url;
  });
}
